(function () {
  'use strict';

  var hintPlayed = false;
  var galleries = new WeakSet();
  var preloadObserver;

  function loadImage(slide, priority) {
    if (!slide) return;
    var image = slide.querySelector('img[data-dc-src]');
    if (!image) return;

    if (priority) image.setAttribute('fetchpriority', priority);
    image.src = image.getAttribute('data-dc-src');
    image.removeAttribute('data-dc-src');
    if (image.hasAttribute('data-dc-srcset')) {
      image.srcset = image.getAttribute('data-dc-srcset');
      image.removeAttribute('data-dc-srcset');
    }
  }

  function updateGallery(gallery) {
    var track = gallery.querySelector('[data-dc-card-track]');
    var slides = gallery.querySelectorAll('[data-dc-card-slide]');
    if (!track || !slides.length) return;

    var index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    var dots = gallery.querySelectorAll('[data-dc-card-dot]');

    slides.forEach(function (slide, slideIndex) {
      var active = slideIndex === index;
      slide.tabIndex = active ? 0 : -1;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === index);
    });
    loadImage(slides[index]);
    if (index > 0) loadImage(slides[index + 1], 'low');
  }

  function observePreload(gallery) {
    if (!('IntersectionObserver' in window)) return;

    if (!preloadObserver) {
      preloadObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var slides = entry.target.querySelectorAll('[data-dc-card-slide]');
          loadImage(slides[1], 'low');
          preloadObserver.unobserve(entry.target);
        });
      }, { rootMargin: '300px 0px', threshold: 0 });
    }

    preloadObserver.observe(gallery);
  }

  function playHint(gallery) {
    if (hintPlayed || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    hintPlayed = true;

    var secondSlide = gallery.querySelectorAll('[data-dc-card-slide]')[1];
    var track = gallery.querySelector('[data-dc-card-track]');
    loadImage(secondSlide, 'high');
    if (!track) return;

    var started = false;
    function startHint() {
      if (started) return;
      started = true;
      track.classList.add('is-hinting');
      track.addEventListener('animationend', function () {
        track.classList.remove('is-hinting');
      }, { once: true });
    }

    var secondImage = secondSlide.querySelector('img');
    if (secondImage.complete) {
      window.setTimeout(startHint, 150);
    } else {
      secondImage.addEventListener('load', startHint, { once: true });
      secondImage.addEventListener('error', startHint, { once: true });
      window.setTimeout(startHint, 1000);
    }
  }

  function initGallery(gallery, isFirst) {
    if (galleries.has(gallery)) return;
    galleries.add(gallery);

    var track = gallery.querySelector('[data-dc-card-track]');
    var slides = gallery.querySelectorAll('[data-dc-card-slide]');
    if (!track || slides.length < 2) return;

    var frame = 0;
    var startX = 0;
    var startY = 0;
    var dragged = false;

    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () { updateGallery(gallery); });
    }, { passive: true });

    track.addEventListener('pointerdown', function (event) {
      startX = event.clientX;
      startY = event.clientY;
      dragged = false;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      loadImage(slides[index + 1], 'high');
      loadImage(slides[index - 1], 'low');
    }, { passive: true });

    track.addEventListener('pointermove', function (event) {
      if (Math.abs(event.clientX - startX) > 8 && Math.abs(event.clientX - startX) > Math.abs(event.clientY - startY)) {
        dragged = true;
      }
    }, { passive: true });

    track.addEventListener('click', function (event) {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
      }
    }, true);

    updateGallery(gallery);
    observePreload(gallery);

    if (isFirst && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          playHint(gallery);
        }
      }, { threshold: 0.45 });
      observer.observe(gallery);
    }
  }

  function initAll() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var items = document.querySelectorAll('[data-dc-card-gallery]');
    items.forEach(function (gallery, index) { initGallery(gallery, index === 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', initAll);

  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
}());
